import { ReactNode, useEffect, useRef } from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import { Toast } from 'primereact/toast'
import { toastAtom } from '@/atoms/toastAtom'
import { useSetAtom } from 'jotai'
import { useTokenRefreshMonitor } from '@/api/hooks/useTokenRefreshMonitor'

interface MainLayoutProps {
  children: ReactNode
}

/**
 * メインレイアウトコンポーネント
 *
 * ヘッダーとフッターを含む基本的な縦スタック型レイアウト
 */
function MainLayout({ children }: MainLayoutProps) {
  const toastRef = useRef<Toast>(null)
  const setToast = useSetAtom(toastAtom)

  // トークン自動更新監視を開始
  useTokenRefreshMonitor()

  useEffect(() => {
    if (toastRef.current) {
      setToast(toastRef.current as Toast)
    }
  }
  , [setToast])


  return (
    <div className="tw-grid tw-h-screen tw-grid-cols-1 tw-grid-rows-[auto_1fr_auto] tw-gap-0">
      <Header />
      <main>
        {children}
      </main>
      <Footer />
      <Toast ref={toastRef} />
    </div>
  )
}

export default MainLayout
